import {
  GET_TIME_ENTRIES,
  UPDATE_TIME_ENTRY,
  DELETE_TIME_ENTRY,
  CREATE_TIME_ENTRY,
  CREATE_TIME_ENTRY_AS_DELEGATE,
  DELETE_TIME_ENTRY_AS_DELEGATE,
  GET_TIME_ENTRIES_AS_DELEGATE,
  UPDATE_TIME_ENTRY_AS_DELEGATE,
  PROCESS_TIMESHEETS,
  GET_TIME_ENTRIES_BY_PROJECT,
  SPLIT_TIME_ENTRY,
} from './query'
import { getUpdatedTimeEntryEvent } from '../../../server/actions/helpers/timeEntryActionHelper'
import { addEventDataToEntry } from '../../../server/funnel/funnelUtils'

export const fetchTimeEntriesInDateRange = async ({
  client,
  startISO,
  endISO,
  selectedDelegateId,
  noChild = false,
}) => {
  const { data } = await client.query({
    query: selectedDelegateId ? GET_TIME_ENTRIES_AS_DELEGATE : GET_TIME_ENTRIES,
    variables: {
      startISO,
      endISO,
      delegateId: selectedDelegateId,
      noChild,
    },
  })
  return selectedDelegateId ? data.getTimeEntries_asDelegate : data.getTimeEntries
}

export const updateTimeEntry = async ({ client, timeEntry, selectedDelegateId }) => {
  const updatedTimeEntryEvent = getUpdatedTimeEntryEvent(timeEntry)

  const { data } = await client.query({
    query: selectedDelegateId ? UPDATE_TIME_ENTRY_AS_DELEGATE : UPDATE_TIME_ENTRY,
    variables: {
      delegateId: selectedDelegateId,
      ...updatedTimeEntryEvent,
    },
  })

  const updatedTimeEntry = selectedDelegateId
    ? data.updateTimeEntry_asDelegate
    : data.updateTimeEntry

  return addEventDataToEntry(updatedTimeEntry)
}

export const processTimesheets = async ({ client, entries }) => {
  const { data } = await client.mutate({
    mutation: PROCESS_TIMESHEETS,
    variables: { entries },
  })
  return data.processTimesheets
}

export const deleteTimeEntry = async ({ client, timeEntry, selectedDelegateId }) => {
  await client.mutate({
    mutation: selectedDelegateId ? DELETE_TIME_ENTRY_AS_DELEGATE : DELETE_TIME_ENTRY,
    variables: {
      _id: timeEntry._id,
      delegateId: selectedDelegateId,
    },
  })
}

export const createTimeEntry = async ({ client, timeEntry, selectedDelegateId }) => {
  const { data } = await client.mutate({
    mutation: selectedDelegateId ? CREATE_TIME_ENTRY_AS_DELEGATE : CREATE_TIME_ENTRY,
    variables: {
      delegateId: selectedDelegateId,
      billable: timeEntry.billable,
      end: timeEntry.end,
      originalComment: timeEntry.originalComment,
      originalDurationInHours: timeEntry.originalDurationInHours,
      originalEntryDate: timeEntry.originalEntryDate,
      originalProjectId: timeEntry.originalProjectId,
      referenceId: timeEntry.referenceId,
      referenceType: timeEntry.referenceType,
      repliconTimesheetId: timeEntry.repliconTimesheetId,
      sourceId: timeEntry.sourceId,
      start: timeEntry.start,
      creationWay: timeEntry.creationWay,
      eventTagId: timeEntry.eventTagId,
    },
  })
  return selectedDelegateId ? data.createTimeEntry_asDelegate : data.createTimeEntry
}

export const getTimeEntriesByProject = async ({
  projectId,
  client,
  repliconTimesheetId,
  approveState,
  onlyInActiveInvoice,
}) => {
  const { data } = await client.query({
    query: GET_TIME_ENTRIES_BY_PROJECT,
    variables: {
      projectIds: projectId,
      repliconTimesheetId,
      approveState,
      onlyInActiveInvoice,
    },
  })

  return data.getTimeEntriesByProjectIds
}

export const splitTimeEntry = async ({
  client,
  timeEntryId,
  durationInHours,
  comment,
  statusses,
}) => {
  const { data } = await client.mutate({
    mutation: SPLIT_TIME_ENTRY,
    variables: {
      entryId: timeEntryId,
      durationInHours,
      comment,
      statusses,
    },
  })

  return data.splitTimeEntry
}
